exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-page>div[data-v-5b8d6e0c]{background:#fff}.index-page>div[data-v-5b8d6e0c]:nth-of-type(odd){background:#f5f6f8}.row[data-v-5b8d6e0c]{display:flex}.column.half[data-v-5b8d6e0c]{width:50%}section.inspiration[data-v-5b8d6e0c]{padding-right:0;padding-left:0}@media (max-width:767px){.row[data-v-5b8d6e0c]{flex-wrap:wrap}.row .column.half[data-v-5b8d6e0c]{width:100%}h1[data-v-5b8d6e0c]{font-size:2.7em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b8d6e0c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/pages/index/style.scss
// module id = 891
// module chunks = 0